/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Pedagogy12Inputs */

const en__field_enum_tuda_pedagogy12 = /** @type {(inputs: _Field_Enum_Tuda_Pedagogy12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching & Pedagogy`)
};

const de__field_enum_tuda_pedagogy12 = /** @type {(inputs: _Field_Enum_Tuda_Pedagogy12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt & Pädagogik`)
};

/**
* | output |
* | --- |
* | "Teaching & Pedagogy" |
*
* @param {_Field_Enum_Tuda_Pedagogy12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_pedagogy12 = /** @type {((inputs?: _Field_Enum_Tuda_Pedagogy12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Pedagogy12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_pedagogy12(inputs)
	return de__field_enum_tuda_pedagogy12(inputs)
});
export { _field_enum_tuda_pedagogy12 as "_field_enum_TUDA_PEDAGOGY" }